export default (err: any): void => console.log(err)
